import type { ComponentType } from "react"
import { Suspense } from "react"
import { useIsMobile } from "@/hooks/useIsMobile"
import { AuthLayout } from "@/layout/AuthLayout"
import { MobileAuthLayout } from "@/layout/MobileAuthLayout"

interface ResponsiveAuthRouteProps {
  desktop: ComponentType
  mobile: ComponentType
  showBackButton?: boolean
  showLogo?: boolean
  enableSmartNavigation?: boolean
  onNavigateBack?: () => void
  centerContent?: boolean
}

export function ResponsiveAuthRoute({
  desktop: DesktopScreen,
  mobile: MobileScreen,
  showBackButton = true,
  showLogo = true,
  enableSmartNavigation = false,
  onNavigateBack,
  centerContent = false,
}: ResponsiveAuthRouteProps) {
  const isMobile = useIsMobile()

  if (isMobile === undefined) {
    return (
      <div className="min-h-screen bg-brand-dark">
        <div className="absolute inset-0 bg-brand-dark animate-pulse" />
      </div>
    )
  }

  if (isMobile) {
    return (
      <MobileAuthLayout
        showBackButton={showBackButton}
        showLogo={showLogo}
        enableSmartNavigation={enableSmartNavigation}
        onNavigateBack={onNavigateBack}
        centerContent={centerContent}
      >
        <Suspense fallback={<div className="min-h-screen bg-brand-dark" />}>
          <MobileScreen />
        </Suspense>
      </MobileAuthLayout>
    )
  }

  return (
    <AuthLayout
      showBackButton={showBackButton}
      enableSmartNavigation={enableSmartNavigation}
      onNavigateBack={onNavigateBack}
    >
      <Suspense fallback={<div className="min-h-screen bg-brand-dark" />}>
        <DesktopScreen />
      </Suspense>
    </AuthLayout>
  )
}
